import { useEffect, useState } from "react";
import { toast } from "sonner";
import { Trash2, MessageCircle, FileDown, Eye } from "lucide-react";
import { api, errMsg, waLink } from "@/lib/api";

export const AdminLeads = () => {
  const [leads, setLeads] = useState([]);
  const load = () => api.get("/admin/leads").then((r) => setLeads(r.data)).catch((e) => toast.error(errMsg(e)));
  useEffect(() => { load(); }, []);
  const remove = async (id) => { if (!window.confirm("¿Eliminar este contacto?")) return; await api.delete(`/admin/leads/${id}`); load(); };

  if (!leads.length) return <p className="text-[#5C635E]" data-testid="admin-leads-empty">Todavía nadie pidió el catálogo.</p>;
  return (
    <div className="card-fv overflow-x-auto" data-testid="admin-leads">
      <table className="w-full text-sm">
        <thead className="bg-[#F3EAD7]/60 text-left text-xs uppercase tracking-wider text-[#5C635E]">
          <tr>{["Última vez", "Nombre", "WhatsApp", "Email", "Desde", "Actividad", ""].map((h) => <th key={h} className="px-4 py-3">{h}</th>)}</tr>
        </thead>
        <tbody className="divide-y">
          {leads.map((l) => (
            <tr key={l.id} data-testid={`admin-lead-row-${l.id}`}>
              <td className="px-4 py-3 whitespace-nowrap text-[#5C635E]">{new Date(l.last_at || l.created_at).toLocaleString("es-CR")}</td>
              <td className="px-4 py-3 font-semibold">{l.name}</td>
              <td className="px-4 py-3">
                <a href={waLink(l.whatsapp, `Hola ${l.name}, te escribimos de Hacienda Fernández & Vargas por el catálogo Brangus.`)} target="_blank" rel="noreferrer"
                  className="inline-flex items-center gap-1 text-[#1D3324] hover:text-[#8B2B22]" data-testid={`admin-lead-whatsapp-${l.id}`}><MessageCircle size={14} />{l.whatsapp}</a>
              </td>
              <td className="px-4 py-3">{l.email ? <a href={`mailto:${l.email}`} className="hover:text-[#8B2B22]">{l.email}</a> : "—"}</td>
              <td className="px-4 py-3">{[l.city, l.country].filter(Boolean).join(", ") || "—"}</td>
              <td className="px-4 py-3">
                <span className="inline-flex items-center gap-3 whitespace-nowrap">
                  <span className="inline-flex items-center gap-1" title="Descargas"><FileDown size={14} />{l.downloads || 0}</span>
                  <span className="inline-flex items-center gap-1" title="Vistas online"><Eye size={14} />{l.views || 0}</span>
                </span>
              </td>
              <td className="px-4 py-3"><button onClick={() => remove(l.id)} className="p-2 text-red-700 hover:bg-red-50" data-testid={`admin-lead-delete-${l.id}`} aria-label="Eliminar"><Trash2 size={15} /></button></td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
};
